import {
  Flex,
  Text,
  type FlexProps,
  type MultiSelectProps,
} from '@mantine/core';
import classes from './FormActivitySphereMultiselect.module.scss';
import { ActivitySphereMultiselect } from '@entities/activitySphere';
import type { ReactNode } from 'react';

interface FormRegionsSelectProps extends Omit<MultiSelectProps, 'title'> {
  title?: string | ReactNode;
  description?: string;
  containerProps?: FlexProps;
}

export const FormActivitySphereMultiselect = ({
  title = 'Сфера деятельности',
  description = 'Выберите все сферы деятельности компании',
  placeholder = 'Выберите',
  containerProps,
  ...props
}: FormRegionsSelectProps) => {
  return (
    <Flex gap='24' className={classes.formRow} {...containerProps}>
      <Flex direction='column' gap={6} className={classes.leftColumn}>
        {typeof title === 'string' ? (
          <Text className={classes.title}>{title}</Text>
        ) : (
          title
        )}
        <Text className={classes.description}>{description}</Text>
      </Flex>

      <ActivitySphereMultiselect
        {...props}
        placeholder={placeholder}
        className={classes.rightColumn}
        variant='filled'
      />
    </Flex>
  );
};
